import { createSelector } from "reselect";
import get from "lodash/get";
import helpers from "../../common/utils/utils";
import { cropNumber } from "../../common/helpers/helpers";

const gwasSchemaSelector = createSelector(
  (state) => state.schema,
  (schema) => schema && schema.properties
);

const gwasVariantSelector = createSelector(
  (state) => state.variantResult,
  (variantResult) => variantResult
);

const gwasVariantVersionSelector = createSelector(
  gwasVariantSelector,
  (variant) => get(variant, "gwas.0.version") || null
);

const gwasLabelsSelector = createSelector(gwasSchemaSelector, (schema) => {
  const path = "gwas.items.properties.items.items.properties";
  return {
    confidenceRange: "Confidence range 95%",
    oddsRatio: " Odds ratio or beta",
    replicationSampleSize: get(schema, `${path}.replication_sample_size.label`),
    initialSampleSize: get(schema, `${path}.initial_sample_size.label`),
    mappedTraits: get(schema, `${path}.mapped_traits.label`),
    date: get(schema, `${path}.date.label`),
    diseaseOrTrait: get(schema, `${path}.disease_or_trait.label`),
    pValue: get(schema, `${path}.p_value.label`),
    strongestRiskAllele: get(schema, `${path}.strongest_snp_risk_allele.label`),
    pubMedReferences: get(schema, `${path}.pub_med_references.label`),
  };
});

const gwasItemsSelector = createSelector(gwasVariantSelector, (variant) => {
  return get(variant, "gwas.0.items") || [];
});

const gwasListSelector = createSelector(gwasItemsSelector, (items) => {
  return items.map((x, i) => {
    const snps = (x.strongest_snp_risk_allele || "").split("-");
    const snp = snps.length === 2 ? snps[1] : x.strongest_snp_risk_allele;
    return {
      ...x,
      strongestRiskAllele: snp,
      readableDate: helpers.parseNumericDate(x.date),
      pubMedRefs: x.pub_med_references,
      oddsRatio: cropNumber(x.odds_ratio),
      confidenceLow: cropNumber(x.confidence_range_95_low),
      confidenceHigh: cropNumber(x.confidence_range_95_high),
      pValue: x.p_value ? x.p_value.toLowerCase() : null,
      diseaseOrTrait: x.disease_or_trait,
      confidenceComment: x.confidence_comment,
      id: `${i}${new Date()}`,
    };
  });
});

export { gwasListSelector, gwasLabelsSelector, gwasVariantVersionSelector };
